module.exports = __webpack_public_path__ + "static/parisian-views-001549c458ba4949c35c5c5e8a235e16.jpg";